import React from "react";
import Content from '../views/PrivacyPolicy';

export default ({location}) => (
  <Content location={location} seo={{
      title: "Terms of Service",
      updated: "Updated on 16 August 2022",
      lang: 'en'
    }}/>
);